'use client';

import { useTranslations } from 'next-intl';
import { Icon } from '@/lib/ui-kit/icons';

export const OrderBookHeader = ({ label, onCenter }: { label?: string; onCenter?: () => void }) => {
  const t = useTranslations('orderBook');
  return (
    <div
      className="border-b border-v2-border flex h-9 w-full shrink-0 items-end gap-3 px-3 pb-2 text-[10px] leading-[1.5] text-v2-text-secondary
        md:px-4"
    >
      <div className="flex flex-1 items-center gap-2">
        {/* Tabs already show Trade Yes/No below 361px — avoid duplicating the label */}
        {label && <span className="hidden min-[361px]:inline">{label}</span>}
        {onCenter && (
          <button
            type="button"
            onClick={onCenter}
            aria-label="Center order book"
            className="cursor-pointer transition-colors hover:text-v2-text-primary"
          >
            <Icon name="SliderVertical" size={16} />
          </button>
        )}
      </div>
      <div className="min-w-12 flex-1 text-end">{t('price')}</div>
      <div className="min-w-12 flex-1 text-end">{t('shares')}</div>
      <div className="flex-1 text-end">{t('total')}</div>
    </div>
  );
};
